import { questions, type Profile } from "../data/questions";

export interface ScoringResult {
  profile: Profile;
  scores: Record<Profile, number>;
  percentage: number; // 55–95 — affiché sur la card "X% match"
}

export function computeProfile(answerIndices: number[]): ScoringResult {
  const totals: Record<Profile, number> = {
    visionnaire: 0,
    chill: 0,
    stratege: 0,
    ambitieux: 0,
    securitaire: 0,
  };

  answerIndices.forEach((answerIdx, qIdx) => {
    const q = questions[qIdx];
    if (!q || answerIdx < 0 || answerIdx >= q.answers.length) return;
    const scores = q.answers[answerIdx].scores;
    for (const [k, v] of Object.entries(scores)) {
      totals[k as Profile] += v ?? 0;
    }
  });

  const ranked = (Object.entries(totals) as [Profile, number][]).sort(
    (a, b) => b[1] - a[1]
  );

  // Tie-break : Q2 (id=2 → index 1) puis Q8 (id=8 → index 7)
  let winner = ranked[0][0];
  if (ranked.length >= 2 && ranked[0][1] === ranked[1][1]) {
    const tied = ranked
      .filter(([, s]) => s === ranked[0][1])
      .map(([p]) => p);
    for (const tieIdx of [1, 7]) {
      const a = questions[tieIdx]?.answers[answerIndices[tieIdx]];
      if (!a) continue;
      const found = tied.find((p) => (a.scores[p] ?? 0) > 0);
      if (found) {
        winner = found;
        break;
      }
    }
  }

  const top = totals[winner];
  const sum = Object.values(totals).reduce((a, b) => a + b, 0);
  const percentage = Math.min(
    95,
    Math.max(55, Math.round((top / Math.max(sum, 1)) * 300))
  );

  return { profile: winner, scores: totals, percentage };
}
